import { render, staticRenderFns } from "./openingCollection.vue?vue&type=template&id=9bae0dac&scoped=true"
import script from "./openingCollection.vue?vue&type=script&lang=js"
export * from "./openingCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bae0dac",
  null
  
)

export default component.exports